export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions4.82dea9c3.png";